module.exports = __webpack_public_path__ + "static/img/limit_06.72d3d4fd.svg";